import { createSlice, PayloadAction } from '@reduxjs/toolkit';
interface Properties {
    top: number;
    left: number;
}
interface Note {
    id: number;
    book_id: number;
    text: string;
    cfi: string;
    page_no: number;
    href: string;
    is_active: boolean;
    created_at: string;
    updated_at: string;
    properties: Properties;
}
interface NotesState {
    notes: Note[];
}

const initialState: NotesState = {
    notes: [],
};

const notesSlice = createSlice({
    name: 'notes',
    initialState,
    reducers: {
        setNotes: (state, action: PayloadAction<Note[]>) => {
            state.notes = action.payload;
        },
        appendNote: (state, action: PayloadAction<Note>) => {
            state.notes.push(action.payload);
        },
        removeNote: (state, action: PayloadAction<number>) => {
            state.notes = state.notes.filter(
                (note) => note.id !== action.payload
            );
        },
        updateNote: (
            state,
            action: PayloadAction<{ id: number; text: string }>
        ) => {
            const { id, text } = action.payload;
            state.notes = state.notes.map((note) =>
                note.id === id
                    ? { ...note, text, updated_at: new Date().toISOString() } // Creating a new object
                    : note
            );
        },
    },
});

export const { setNotes, appendNote, removeNote, updateNote } =
    notesSlice.actions;
export default notesSlice.reducer;
